import { isMobile } from './checkMobile';

/**
 * 엑셀 버튼 표시 여부를 확인하는 함수
 * @param {boolean} excelAuth - 엑셀 권한 여부
 * @returns {boolean} 엑셀 버튼 표시 여부
 */
export const showExcelButton = (excelAuth: boolean): boolean => {
  return excelAuth && !isMobile();
};

/**
 * 프린트 버튼 표시 여부를 확인하는 함수
 * @param {boolean} printAuth - 프린트 권한 여부
 * @returns {boolean} 프린트 버튼 표시 여부
 */
export const showPrintButton = (printAuth: boolean): boolean => {
  return printAuth && !isMobile();
};
